import React from 'react'
import DeleteIcon from '@mui/icons-material/Delete'
import { client } from '../../utils/client'
import { useDispatch } from 'react-redux'
import { setLoading, showSnackbar } from '../../actions/pageActions'
import { IconButton } from '@mui/material'
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog'
import { COMPANIES_PATH } from '../../constants/endpointsConstants'

const DeleteCompany = ({ company, onDelete }) => {
  const dispatch = useDispatch()

  const deleteCompany = () => {
    dispatch(setLoading(true))
    client
      .delete(`${COMPANIES_PATH}/${company.id}`)
      .then(() => {
        dispatch(setLoading(false))
        dispatch(showSnackbar('Empresa eliminada', 'success'))
        onDelete(company.id)
      })
      .catch(() => {
        dispatch(setLoading(false))
        dispatch(showSnackbar('Error al eliminar la empresa', 'error'))
      })
  }
  return (
    <ConfirmDialog
      buttonOpen={
        <IconButton color="error">
          <DeleteIcon />
        </IconButton>
      }
      title="Eliminar empresa"
      body={`¿Deseas eliminar a "${company.name}"?`}
      onConfirm={deleteCompany}
    />
  )
}

export default DeleteCompany
